import { render } from "./uploadAnnex.vue?vue&type=template&id=2514b00f&scoped=true"
import script from "./uploadAnnex.vue?vue&type=script&lang=js"
export * from "./uploadAnnex.vue?vue&type=script&lang=js"

import "./uploadAnnex.vue?vue&type=style&index=0&id=2514b00f&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2514b00f"]])

export default __exports__